var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((16),function(c){return _c('div',{key:c},_vm._l((16),function(r){return _c('div',{key:r},[_c('Block',{attrs:{"x":c-1,"y":r-1}})],1)}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }